import { ChangeDetectionStrategy,Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';

import { CopyToClipboardComponent } from 'app/shared/utilities/copy-to-clipboard.component';

export interface ExpireProjectResultDialogData {
    url: string
}

@Component({
    templateUrl: './expire-project-result-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatDialogTitle, MatDialogContent, FormsModule, MatDialogActions, MatButton, MatDialogClose, CopyToClipboardComponent]
})
export class ExpireProjectResultDialogComponent {
    data = inject<ExpireProjectResultDialogData>(MAT_DIALOG_DATA);
}
